import { makeStyles, mergeClasses } from '@fluentui/react-components';
import { tokens } from '@fluentui-copilot/tokens';
import type { CopilotChatSlots, CopilotChatState } from './CopilotChat.types';
import type { SlotClassNames } from '@fluentui/react-components';

export const copilotChatClassNames: SlotClassNames<CopilotChatSlots> = {
  root: 'fai-CopilotChat',
  // TODO: add class names for all slots on CopilotChatSlots.
  // Should be of the form `<slotName>: 'fai-CopilotChat__<slotName>`
};

/**
 * Styles for the root slot
 */
const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalM,
  },

  // TODO add additional classes for different states and/or slots
});

/**
 * Apply styling to the CopilotChat slots based on the state
 */
export const useCopilotChatStyles_unstable = (state: CopilotChatState): CopilotChatState => {
  'use no memo';

  const styles = useStyles();
  state.root.className = mergeClasses(copilotChatClassNames.root, styles.root, state.root.className);

  // TODO Add class names to slots, for example:
  // state.mySlot.className = mergeClasses(styles.mySlot, state.mySlot.className);

  return state;
};
